var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9031 40.122C56.9031 37.8967 58.7012 36.0986 60.9265 36.0986V29.5651C60.9265 28.4257 60.0007 27.5 58.8614 27.5H21.5651C20.4257 27.5 19.5 28.4257 19.5 29.5651V36.1164C21.7253 36.1164 23.5234 37.9145 23.5234 40.1398C23.5234 42.3651 21.7253 44.1632 19.5 44.1632V50.7145C19.5 51.8539 20.4257 52.7796 21.5651 52.7796H58.8436C59.9829 52.7796 60.9087 51.8539 60.9087 50.7145V44.1632C58.6834 44.1632 56.8853 42.3651 56.8853 40.1398L56.9031 40.122Z",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7461 36.276C32.7461 38.0384 33.8855 39.5517 36.004 39.5517C38.1225 39.5517 39.2618 38.0741 39.2618 36.276V35.4927C39.2618 33.6946 38.1403 32.1992 36.004 32.1992C33.8677 32.1992 32.7461 33.6946 32.7461 35.4927V36.276ZM35.5945 47.5628C35.8437 47.5628 36.093 47.4382 36.2354 47.2246L45.3859 33.9261C45.7419 33.4098 45.3859 32.7155 44.745 32.7155C44.4958 32.7155 44.2465 32.8401 44.1041 33.0537L34.9536 46.3522C34.5976 46.8685 34.9536 47.5628 35.5945 47.5628ZM34.8468 35.4927C34.8468 34.7984 35.1316 34.0329 36.004 34.0329C36.9297 34.0329 37.1611 34.7806 37.1611 35.4927V36.276C37.1611 36.9881 36.8941 37.718 36.004 37.718C35.1138 37.718 34.8468 36.9881 34.8468 36.276V35.4927ZM41.1667 44.7678C41.1667 46.5303 42.3061 48.0613 44.4246 48.0613C46.5431 48.0613 47.6824 46.5303 47.6824 44.7678V43.9845C47.6824 42.1864 46.5431 40.691 44.4246 40.691C42.3061 40.691 41.1667 42.222 41.1667 43.9845V44.7678ZM43.2496 43.9845C43.2496 43.2724 43.5344 42.5247 44.4246 42.5247C45.3147 42.5247 45.5817 43.2724 45.5817 43.9845V44.7678C45.5817 45.4799 45.3147 46.2098 44.4246 46.2098C43.5344 46.2098 43.2496 45.4621 43.2496 44.7678V43.9845Z",
    fill: "#D6CEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#7762DF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon_icon.7444207904c6cdddfb1cf8dba3cd01d4.svg";
export { ForwardRef as ReactComponent };